define('extensible-option-group',['elements'], function(elements) {
	function init(elements) {
		elements.find('.extensible-option-group').each(function() {
			var group = $(this);
			var option = group.children('.option').find('input[type=radio]');
			var details = group.children('.details');

			// radio button's onchange handler is not triggered on uncheck, so we need to listen
			// on all radio buttons with the same name in the form
			var form = option.closest('form');
			var triggers;
			if (form.length) {
				triggers = form.find('input[type=radio][name=' + option.attr('name') + ']');
			} else {
				triggers = option;
			}

			if (!option.is(':checked')) {
				details.hide();
			}

			triggers.change(function() {
				if (details.is(':visible') != option.is(':checked')) {
					if (option.is(':checked')) {
						details.slideDown(); // show
					} else {
						details.slideUp(); // hide
					}
				}
			});
		});
	}

	elements.register(init);

	return {
		init: init
	};
});

